export default __webpack_public_path__ + "static/media/kites.6936a3db.png";